import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import {push as changeURL} from 'react-router-redux';
import mapDispatch from '~/misc/mapDispatch';

import sharedCSS from '~/components/shared.css';
import css from './index.css';
import Tabs from '../../tabs/tabs';
import CompanySaved from './saved';
import {alterHideConfirm} from '~/modules/hideConfirm/actions';
import {addCompany} from '~/modules/myCompany/actions';
import {track} from '~/misc/metrics';

class MyCompany extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
    this.titleClcik = this.titleClcik.bind(this);
  }
  componentWillMount() {
    track('my brokers/shippers', {'My brokers – homepage': 1});
    // 未登录返回首页
    if (!this.props.user.token) {
      this.props.gotoRoot();
    }
    if (this.props.user.token) {
      this.setState({loading: true});
      Promise.all([this.props.addCompany('save'), this.props.addCompany('hide')])
        .then(() => {this.setState({loading: false});}).catch(() => {this.setState({loading: false});});
    }
    this.props.alterHideConfirm({hideConfirm: false});
  }
  componentWillReceiveProps(nexProps) {
    // 登录返回首页
    if (!nexProps.user.isLoggedIn && !nexProps.user.loading) {
      this.props.gotoRoot();
    }
  }
  render() {
    return (
      <div className={cs(sharedCSS.widewrap)}>
        <div className={cs(sharedCSS.wideStretchable, css.wrap)}>
          {this.renderForm()}
        </div>
      </div>
    );
  }
  renderForm() {
    return (
      <div className={cs(sharedCSS.wideStretchable, sharedCSS.unpadded, css.wrapMargin)}>
        <Tabs
          id='myCompany'
          tabs={[
            {id: 'saved', title: 'Saved', dataqa: 'saved'},
            {id: 'hidden', title: 'Hidden', dataqa: 'hidden'},
          ]}
          content={{
            saved: <CompanySaved
              loading={this.state.loading}
              type='save'
            />,
            hidden: <CompanySaved
              loading={this.state.loading}
              type='hide'
            />,
          }}
          csContents={css.contentWrapper}
          clickFun={this.titleClcik}
        />
      </div>
    );
  }
  titleClcik(title) {
    switch(title) {
      case 'saved':
        track('my brokers/shippers', {'Saved': 1});
        break;
      case 'hidden':
        track('my brokers/shippers', {'Hidden': 1});
        break;
    }
  }
}

export default connect(({user, myCompany}) => ({
  item: myCompany.hide,
  user,

}), mapDispatch({
  alterHideConfirm: (props, data) => alterHideConfirm(data),
  addCompany: (props, data) => addCompany(data),
  gotoRoot: () => changeURL('/'),
}))(MyCompany);



// WEBPACK FOOTER //
// ./src/components/pages/MyCompany/index.js